import React from 'react';
type BravePathProps = {
  className?: string;
};

/** The dotted "Brave Path" motif from the product covers: sage → terracotta → golden sun. */
export function BravePath({
  className = ''
}: BravePathProps) {
  return <svg viewBox="0 0 240 40" fill="none" aria-hidden="true" className={className} data-id="element-30" data-mp="2tdthvq0k0cy0">
      <path d="M8 30 C 50 32, 70 14, 112 16 S 182 32, 232 9" stroke="#7C917B" strokeWidth="2" strokeLinecap="round" strokeDasharray="0.5 6" data-id="element-31" data-mp="2yd6bctlxki9k" />
      <circle cx="8" cy="30" r="5" fill="#AFC2AE" data-id="element-32" data-mp="2ogbfyjkyexzi" />
      <circle cx="112" cy="16" r="5" fill="#D9826B" data-id="element-33" data-mp="2oh30mzd0jbb0" />
      <circle cx="232" cy="9" r="6" fill="#E9C979" data-id="element-34" data-mp="2ap6av1ythdhs" />
    </svg>;
}